import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { PushApi } from 'api';

/** 작성 화면의 "예상 발송 대상 수" */
function useGetTargetCount() {
  return useAuthQuery(
    getQueryKeys([KEY, 'TARGET_COUNT']).lists(),
    () => PushApi.getTargetCount(),
    {
      select: (data) => data.data.count as number,
    },
  );
}

export default useGetTargetCount;
